// extracted by mini-css-extract-plugin
export default {"component":"GuideCarousel__component-qA9V","loading":"GuideCarousel__loading-NatI","slide":"GuideCarousel__slide-qBNw"};